module.exports = __webpack_public_path__ + "static/media/cx.63585d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cx.png
// module id = 1828
// module chunks = 0